import React from 'react';
import { Box, Skeleton, Grid } from '@mui/material';

const HomeSkeleton: React.FC = () => (
  <Box sx={{ width: '100%', bgcolor: '#1a1b1f' }}>
    {/* Header avec avatar rond */}
    <Box sx={{ display: 'flex', justifyContent: 'center', mb: 30, mt: 18 }}>
      <Skeleton
        variant="circular"
        width={200}
        height={200}
        animation="wave"
        sx={{
          bgcolor: '#2c2f33',
          '&.MuiSkeleton-wave::before': {
            background: `
              linear-gradient(
                120deg,
                transparent 0%,
                rgba(200,200,200,0.1) 50%,
                transparent 100%
              )`,
          },
        }}
      />
    </Box>

    {/* Section About */}
    <Box sx={{ mb: 4, borderRadius: 4, px: { xs: 2, md: 6 }, overflow: 'hidden' }}>
      <Skeleton
        variant="rectangular"
        width="100%"
        height={200}
        animation="wave"
        sx={{
          borderRadius: 4,
          bgcolor: '#2c2f33',
          '&.MuiSkeleton-wave::before': {
            background: `
              linear-gradient(
                120deg,
                transparent,
                rgba(200,200,200,0.1),
                transparent
              )`,
          },
        }}
      />
    </Box>

    {/* Skills & Experience 1/3 - 2/3 */}
    <Grid container spacing={2} sx={{ mb: 4, px: { xs: 2, md: 6 } }}>
      <Grid item xs={12} md={4}>
        <Skeleton
          variant="rectangular"
          width="100%"
          height={600}
          animation="wave"
          sx={{
            borderRadius: 2,
            bgcolor: '#2c2f33',
            '&.MuiSkeleton-wave::before': {
              background: `
                linear-gradient(
                  120deg,
                  transparent,
                  rgba(200,200,200,0.1),
                  transparent
                )`,
            },
          }}
        />
      </Grid>
      <Grid item xs={12} md={8}>
        <Skeleton
          variant="rectangular"
          width="100%"
          height={600}
          animation="wave"
          sx={{
            borderRadius: 2,
            bgcolor: '#2c2f33',
            '&.MuiSkeleton-wave::before': {
              background: `
                linear-gradient(
                  120deg,
                  transparent,
                  rgba(200,200,200,0.1),
                  transparent
                )`,
            },
          }}
        />
      </Grid>
    </Grid>

    {/* Projects */}
    <Box sx={{ px: { xs: 2, md: 6 } }}>
      <Grid container spacing={2} sx={{ mt: 2 }}>
        {[...Array(3)].map((_, idx) => (
          <Grid item xs={12} sm={6} md={4} key={idx}>
            <Skeleton
              variant="rectangular"
              width="100%"
              height={120}
              animation="wave"
              sx={{
                borderRadius: 2,
                bgcolor: '#2c2f33',
                '&.MuiSkeleton-wave::before': {
                  background: `
                    linear-gradient(
                      120deg,
                      transparent,
                      rgba(200,200,200,0.1),
                      transparent
                    )`,
                },
              }}
            />
            {/* <Skeleton variant="text" width="80%" animation="wave" sx={{ bgcolor: '#2c2f33' }} />
            <Skeleton variant="text" width="60%" animation="wave" sx={{ bgcolor: '#2c2f33' }} /> */}
          </Grid>
        ))}
      </Grid>
    </Box>
  </Box>
);

export default HomeSkeleton;
